import styled from 'styled-components';
import { media } from '../../../../ui';
export const SegmentHeader = styled.div.withConfig({
  displayName: "Style__SegmentHeader",
  componentId: "sc-8r3j0g-0"
})(["position:relative;display:flex;align-items:center;padding:15px 20px 15px 30px;overflow:hidden;background-color:", ";border-bottom:1px solid ", ";border-top-left-radius:6px;border-top-right-radius:6px;&:after{position:absolute;top:0;bottom:0;left:0;width:4px;content:'';background-color:", ";}> *:first-child{flex:1;}", ";", ";"], ({
  theme: {
    color
  }
}) => color.white, ({
  theme: {
    color
  }
}) => color.middleGray, ({
  theme: {
    color
  }
}) => color.orange, media.sm`
    padding-left: 20px;
  `, media.xs`
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 20px;
  `);
export const Flex = styled.div.withConfig({
  displayName: "Style__Flex",
  componentId: "sc-8r3j0g-1"
})(["display:flex;"]);
export const FlexFirstPart = styled(Flex).withConfig({
  displayName: "Style__FlexFirstPart",
  componentId: "sc-8r3j0g-2"
})(["", ";"], media.xs`
    flex-direction: column;
  `);
export const Direction = styled.div.withConfig({
  displayName: "Style__Direction",
  componentId: "sc-8r3j0g-3"
})(["margin-right:5px;font-size:", "px;", ";"], ({
  theme: {
    fontSize
  }
}) => fontSize.lg, media.xs`
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.md}px;
  `);
export const Date = styled.div.withConfig({
  displayName: "Style__Date",
  componentId: "sc-8r3j0g-4"
})(["font-size:", "px;color:", ";opacity:0.4;", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.lg, ({
  theme: {
    color
  }
}) => color.black, media.xs`
    margin-bottom: 5px;
    font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.md}px;
  `);
export const Carrier = styled.div.withConfig({
  displayName: "Style__Carrier",
  componentId: "sc-8r3j0g-5"
})(["margin-right:15px;"]);
export const Rating = styled.div.withConfig({
  displayName: "Style__Rating",
  componentId: "sc-8r3j0g-6"
})(["display:flex;align-items:end;font-size:", "px;"], ({
  theme: {
    fontSize
  }
}) => fontSize.md);
export const Icon = styled.i.withConfig({
  displayName: "Style__Icon",
  componentId: "sc-8r3j0g-7"
})(["color:", ";"], ({
  theme: {
    color
  }
}) => color.orange);